import { Formik } from 'formik'
import React, { useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { initialValues } from '../../profile/core/_constants'
import { SelectInput } from '../../widgets/components/Input/SelectInput'
import TextInput from '../../widgets/components/Input/TextInput'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import { ToolTipUIForModal } from '../../widgets/components/UI/ToolTipUIForModal'
import TextArea from '../../widgets/components/Input/TextArea'
import { ToolTipUI } from '../../widgets/components/UI/ToolTipUI'
import TagInput from '../../widgets/components/Input/TagInput'
import { Quill } from '../../widgets/components/Input/Quill'
import brandingConfig from '../../../../config/brandingConfig'

const PublishCofounderRequirementModal = ({ isModalActive, setIsModalActive }: any) => {
  const { formatMessage } = useIntl()
  const [quillText, setQuillText] = useState('')

  const handleSubmit = async (values: any, { resetForm }: any) => { }

  return (
    <div>
      <Modal
        show={isModalActive}
        onHide={() => {
          setIsModalActive(false)
        }}
        fullscreen
      >
        <Modal.Header closeButton>
          <div className='d-flex flex-column'>
            <h2>{formatMessage({ id: 'Co-Founder Details' })}</h2>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className='w-100 container'>
            <label className='font-size-16 fw-bold mb-4'>
              {formatMessage({ id: 'Co-Founder Details' })}
              <span>
                <ToolTipUIForModal
                  tooltipText={formatMessage({
                    id: 'Check the box below if you want to list this deal on Founder Market as well.',
                  })}
                />
              </span>
            </label>
            <InfoCard2
              title={formatMessage({ id: `Find Your Co-Founder with ${brandingConfig.brandName}` })}
              desc={formatMessage({
                id: `Discover potential co-founders by posting an invite and connecting with like-minded individuals in the startup ecosystem through ${brandingConfig.brandName}.`,
              })}
              slug={brandingConfig.helpLinks.publishCofounderDetails}
              className='w-100 mb-0'
            />
            <Formik initialValues={initialValues} validationSchema={{}} onSubmit={handleSubmit}>
              {(formik) => (
                <Form>
                  <div className='row'>
                    <div className='col-md-6 col-12'>
                      <TextInput
                        fieldType='text'
                        label={formatMessage({ id: 'Co-Founder Title' })}
                        fieldName='Title'
                        formik={formik}
                        placeholder={formatMessage({ id: 'Enter Title' })}
                        toolTipText={formatMessage({
                          id: 'Enter the title that you would like to offer to the co-founder.',
                        })}
                        isStarRequired={true}
                        isTooltipForModal={true}
                      />
                    </div>
                    <div className='col-md-6 col-12'>
                      <SelectInput
                        label={formatMessage({ id: 'Role Title' })}
                        fieldName='RoleTitle'
                        placeholder={formatMessage({
                          id: 'Select Role Title',
                        })}
                        formik={formik}
                        toolTipText={formatMessage({
                          id: 'Specify the role title that you would be offering to the co-founder in the company.',
                        })}
                        options={['CXO', 'CTO', 'CMO']}
                        isTooltipForModal={true}
                      />
                    </div>
                    <div className='col-md-6 col-12'>
                      <TagInput
                        initialOptions={[]}
                        label={formatMessage({ id: 'Language Proficiency' })}
                        placeholder={''}
                        tooltip={
                          'List the languages that you are looking for proficiency in the co-founder.'
                        }
                      />
                    </div>
                    <div className='col-md-6 col-12'>
                      <TextInput
                        fieldType='number'
                        label={formatMessage({ id: 'Years of Experience' })}
                        fieldName='Expirence'
                        formik={formik}
                        placeholder={formatMessage({ id: 'Enter Years of Experience*' })}
                        toolTipText={formatMessage({
                          id: 'Mention the professional experience that you are looking for in the co-founder (in number of years).',
                        })}
                        isStarRequired={true}
                        isTooltipForModal={true}
                      />
                    </div>
                    <div className='col-md-6 col-12'>
                      <SelectInput
                        label={formatMessage({ id: 'Fundraising Experiance' })}
                        fieldName='FundraisingExp'
                        placeholder={formatMessage({
                          id: 'Select Fundraising Experiance',
                        })}
                        formik={formik}
                        toolTipText={formatMessage({
                          id: 'Specify if you are looking for any prior fundraising experience in the co-founder or not.',
                        })}
                        options={['Yes', 'No']}
                        isTooltipForModal={true}
                      />
                    </div>
                    <div className='col-md-6 col-12'>
                      <SelectInput
                        label={formatMessage({ id: 'Equity Offering' })}
                        fieldName='EquityOffering'
                        placeholder={formatMessage({
                          id: 'Select Equity Offering',
                        })}
                        formik={formik}
                        toolTipText={formatMessage({
                          id: 'Specify if you are offering any equity to the co-founder.',
                        })}
                        options={['Yes', 'No', 'based on performance']}
                        isTooltipForModal={true}
                      />
                    </div>
                    <div className='col-md-6 col-12'>
                      <SelectInput
                        label={formatMessage({ id: 'Commitment level ' })}
                        fieldName='Commitmentlevel '
                        placeholder={formatMessage({
                          id: 'Select Commitment level ',
                        })}
                        formik={formik}
                        toolTipText={formatMessage({
                          id: 'Specify the level of commitment you are expecting the co-founder to bring.',
                        })}
                        options={['Yes', 'No', 'based on performance']}
                        isTooltipForModal={true}
                      />
                    </div>
                    <div className='col-md-12 col-12'>
                      <TextArea
                        label={formatMessage({ id: 'Years of Experience' })}
                        fieldName='Expirence'
                        formik={formik}
                        placeholder={formatMessage({ id: 'Enter Years of Experience*' })}
                        toolTipText={formatMessage({
                          id: 'Describe the qualifications, qualities, experience you are looking forward to in the co-founder.',
                        })}
                        isStarRequired={true}
                        isTooltipForModal={true}
                      />
                    </div>
                    <div className='mb-5'>
                      <div className=''>
                        <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                          {formatMessage({ id: 'Responsibility' })}*{' '}
                          <ToolTipUI
                            tooltipText={formatMessage({
                              id: 'List down the the responsibilities that the co-founder will be liable for.',
                            })}
                          />
                        </label>
                        <Quill quillText={quillText} setQuillText={setQuillText} />
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Modal.Body>
        <Modal.Footer className='container px-0'>
          <div className='d-md-flex w-100 w-md-auto justify-content-end px-md-0 px-0 gap-3'>
            <div className='w-100 order-1 order-md-2 mb-2 mb-md-auto'>
              <button type='submit' className=' btn bg-primary custom-button-property text-white w-100'>
                {formatMessage({ id: 'Submit' })}
              </button>
            </div>
            <div className='w-100 w-md-auto order-2 order-md-1 '>
              <button type='button' className='btn bg-light custom-button-property text-muted w-100'>
                {formatMessage({ id: 'Cancel' })}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default PublishCofounderRequirementModal
